/** Fallback tenant when organisation internal_org_id is unavailable. */
const DEFAULT_VOICE_TENANT_ID = 'yandle'
const DEFAULT_CHAT_TENANT_ID = 'yandle'

/**
 * @param {{ tenantId?: string; channel?: 'voice' | 'chat' }} [options]
 */
export function getYandleAgentTenantId(options = {}) {
  console.log('getYandleAgentTenantId', options);
  const { tenantId, channel = 'voice' } = options
  const trimmed = typeof tenantId === 'string' ? tenantId.trim() : ''
  console.log('trimmed', trimmed);
  if (trimmed) return trimmed

  if (channel === 'chat') {
    return (
      DEFAULT_CHAT_TENANT_ID
    )
  }
  return (
    DEFAULT_VOICE_TENANT_ID
  )
}
